// extracted by mini-css-extract-plugin
module.exports = {"sigCanvas":"sigCanvas__1FDXA","clearCanvas":"clearCanvas__EXPg4"};